import { useEffect, useState } from "react";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from "polotno";
import { Toolbar } from "polotno/toolbar/toolbar";
import { Workspace } from "polotno/canvas/workspace";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import "@blueprintjs/core/lib/css/blueprint.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import { EditableText, Tooltip } from "@blueprintjs/core";
import FontComponant from "../../../design/FontComponant";
import "./Polotno.css";
import DesignSidebar from "../../../components/DesignSidebar";
import CustomeZoombar from "./CustomeZoombar";
import TimeLineControllers from "./TimeLineControllers";
import FigureFitToPage from "../../../components/FigureFitToPageBtn";
import TextOverflowToggle from "./TextOverFlowToggle";
import { unstable_setTextOverflow } from "polotno/config";
export default function EditTshirt({ store }) {
    const navigate = useNavigate();
    const { id, designId } = useParams();
    // const arr = store.pages;
    // store.selectPage(arr[id]?.id);
    const [sizeFormat, setSizeFormat] = useState("inch");
    const [showTooltip, setShowTooltip] = useState(false);
    const [isBgEditable, setIsBgEditable] = useState(false);
    const [isPageReady, setIsPageReady] = useState(false);
    const [isTextOverFlowOn, setIsTextOverFlowOn] = useState(false);

    useEffect(() => {
        const arr = store.pages;
        if (arr[id]?.id) {
            store.selectPage(arr[id].id);
            store.toggleRulers(false);
            setIsPageReady(true);
        }
    }, [id, store]);

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Alt") {
                e.preventDefault();
                setShowTooltip(e.type === "keydown");
            }
        };
        document.addEventListener("keydown", handleKey, true);
        document.addEventListener("keyup", handleKey, true);
        return () => {
            document.removeEventListener("keydown", handleKey, true);
            document.removeEventListener("keyup", handleKey, true);

            /*   scrollToTop(); */
        };
    }, []);

    const TextAiWrite = () => null;

    const sizeChangeHandler = (e) => {
        const val = e.target.value;
        setSizeFormat(val);
        store.setUnit({
            unit: val === "inch" ? "in" : "px",
            dpi: 72,
        });
    };

    const customFontFamily = () => {
        return <FontComponant store={store} />;
    };

    const goToExportHandler = () => {
        const currentPageId = store.activePage?.id || id;
        navigate(`/export/${designId}`, {
            state: {
                from: "edit",
                pageId: currentPageId,
                updatedStoreJson: store.activePage?.toJSON(),
                timestamp: Date.now(),
            },
        });
    };

    const handleUnlockClick = () => {
        const activePage = store.activePage;
        if (!activePage) return;

        setIsBgEditable((prev) => {
            runInAction(() => {
                const existingBg = activePage.children.find(
                    (child) => child.name === "background-image"
                );

                if (existingBg) {
                    if (!prev) {
                        // Unlock background (Make draggable & selectable)
                        existingBg.set({
                            selectable: true,
                            evented: true,
                            lockScalingX: false,
                            lockScalingY: false,
                            lockMovementX: false,
                            lockMovementY: false,
                        });
                    } else {
                        // Lock background (Prevent dragging & scaling)
                        existingBg.set({
                            selectable: false,
                            evented: false,
                            lockScalingX: true,
                            lockScalingY: true,
                            lockMovementX: true,
                            lockMovementY: true,
                        });
                    }
                } else {
                    // Convert background to image only if it doesn't exist
                    const bgValue = activePage.background;
                    if (!bgValue || bgValue === "transparent") return;

                    runInAction(() => {
                        activePage.set({ background: "transparent" });

                        activePage.addElement({
                            id: `background-image-${activePage.id}`,
                            name: "background-image",
                            type: "image",
                            src: bgValue,
                            x: 0,
                            y: 0,
                            width: activePage.width,
                            height: activePage.height,
                            selectable: true,
                            evented: true,
                            lockScalingX: false,
                            lockScalingY: false,
                            lockMovementX: false,
                            lockMovementY: false,
                        });
                    });
                }
            });

            return !prev;
        });
    };

    /*     useEffect(() => {
        scrollToTop();
    }, []);
 */
    const ImageSetBackgroundButton = observer(
        ({ store, element, elements }) => {
            return (
                <button
                    className="bp5-button bp5-minimal"
                    onClick={async () => {
                        const imageSrc = element.src;
                        const imageElementId = element.id;

                        const filterChildren = store.activePage.children.filter(
                            (child) => child.id !== imageElementId
                        );
                        store.activePage.set({
                            background: imageSrc,
                            children: filterChildren,
                        });
                    }}
                >
                    Set Background
                </button>
            );
        }
    );

    const None = () => null;


    const TextUpperCaseButton = observer(({ store, element, elements }) => {

        const textElement = element;
        const isUpperCase = !textElement.custom?.isUpperCase;
        const isLowerCase = !isUpperCase;


        return (
            <button
                className="bp5-button bp5-minimal"
                style={{
                    background: !isUpperCase ? "lightgrey" :  "none"
                }}
                onClick={async () => {

                    textElement.set({
                        text: isUpperCase
                            ? textElement.text.toUpperCase()
                            : textElement.text.toLowerCase(),
                        custom: {
                            ...textElement.custom,
                            isUpperCase: isUpperCase,
                            isLowerCase: isLowerCase,
                        },
                    });
                }}
            >
                Aa
            </button>
        );
    });


    const ImageStretch = observer(({ store, element, elements }) => {
        const obj = {
            color: element.stretchEnabled ? "#2A1FB3" : "black",
            backgroundColor: element.stretchEnabled ? "#E4E2FF" : "white",
        };
        return (
            <button
                style={obj}
                className="bp5-button bp5-minimal"
                onClick={async () => {
                    element.set({
                        stretchEnabled: !element.stretchEnabled,
                    });
                }}
            >
                {!element.stretchEnabled ? "Stretch" : "Unstretch"}
            </button>
        );
    });

    const SizeControls = observer(({ store }) => {
        const el = store.selectedElements[0];
        if (!el) return null;
        const widthPixels = Math.round(el?.width);
        const heightPixels = Math.round(el?.height);

        const DPI = 72; // your specified DPI

        const widthInches = (widthPixels / DPI).toFixed(1);
        const heightInches = (heightPixels / DPI).toFixed(1);
        return (
            // <div style={{border: "1px solid #cfd8e7", padding: "5px", borderRadius: "5px"}}>
            <div>
                {sizeFormat === "inch" ? (
                    <>
                        {/* <div>W: {widthInches} in</div>
              <div>H: {heightInches} in</div> */}

                        <button className="bp5-button bp5-minimal">
                            W: {widthInches} in
                        </button>
                        <button className="bp5-button bp5-minimal">
                            H: {heightInches} in
                        </button>
                    </>
                ) : (
                    <>
                        {" "}
                        {/* <div>W: {widthPixels} pixels</div>
              <div>H: {heightPixels} pixels</div> */}
                        <button className="bp5-button bp5-minimal">
                            W: {widthPixels} px
                        </button>
                        <button className="bp5-button bp5-minimal">
                            H: {heightPixels} px
                        </button>
                    </>
                )}
            </div>
        );
    });



    const TextInfo = observer(({ store, element, elements }) => {
        // const selected = store.selectedElements;
        // const element = selected[0]; // assuming single selection

        const widthPixels = Math.round(element?.width);
        const heightPixels = Math.round(element?.height);

        const DPI = 72; // your specified DPI

        const widthInches = (widthPixels / DPI).toFixed(1);
        const heightInches = (heightPixels / DPI).toFixed(1);

        if (element) {
            return (
                // <div style={{border: "1px solid #cfd8e7", padding: "5px", borderRadius: "5px"}}>
                <div>
                    {sizeFormat === "inch" ? (
                        <>
                            {/* <div>W: {widthInches} in</div>
              <div>H: {heightInches} in</div> */}

                            <button className="bp5-button bp5-minimal">
                                W: {widthInches} in
                            </button>
                            <button className="bp5-button bp5-minimal">
                                H: {heightInches} in
                            </button>
                        </>
                    ) : (
                        <>
                            {" "}
                            {/* <div>W: {widthPixels} pixels</div>
              <div>H: {heightPixels} pixels</div> */}
                            <button className="bp5-button bp5-minimal">
                                W: {widthPixels} px
                            </button>
                            <button className="bp5-button bp5-minimal">
                                H: {heightPixels} px
                            </button>
                        </>
                    )}
                </div>
            );
        } /* else {
            return <></>;
        } */
    });

    /*     const scrollToTop = () => {
        document
            .querySelector(".polotno-workspace-inner")
            .scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
            document
                .querySelector(".polotno-workspace-inner")
                .scrollTo({ top: 0, behavior: "smooth" });
        }, 1000);

        setTimeout(() => {
            document
                .querySelector(".polotno-workspace-inner")
                .scrollTo({ top: 0, behavior: "smooth" });
        }, 2000);
    };
 */


     const TextAutoFitToggle = observer(({ store }) => {
        const page = store.activePage;
        if (!page) return null;
      
        const isOn = page.custom?.textAutoFitEnabled ?? true;
      
        return (
          <button
            className="bp5-button bp5-minimal"
            style={{
              color: isOn ? "#2A1FB3" : "black",
              backgroundColor: isOn ? "#E4E2FF" : "white",
            }}
            onClick={() => {
              page.set({
                custom: {
                  ...(page.custom || {}),
                  textAutoFitEnabled: !isOn,
                },
              });
            }}
            title="Toggle text auto-fit for this page"
          >
            Auto-Fit
          </button>
        );
      });
    
    
      useEffect(() => {
        const el = store.selectedElements[0];
        if (!el || el.type !== "text") return;
      
        const isAutoFitOn =
        store.activePage?.custom?.textAutoFitEnabled === undefined
          ? true
          : store.activePage.custom.textAutoFitEnabled;
          
          
        if (isAutoFitOn) {
          unstable_setTextOverflow("resize");
          unstable_setTextOverflow("change-font-size");
        } else {
            unstable_setTextOverflow("resize");
        }
      }, [
        store.selectedElements[0]?.id,
        store.activePage?.id,
        store.activePage?.custom?.textAutoFitEnabled,
      ]);
      
    return (
        <PolotnoContainer
            style={{ width: "100vw", height: "100vh" }}
            className="polotno-container"
        >
            <SidePanelWrap className="polotno-sidebar">
                <Link
                    to="/"
                    className="sidebar-logo"
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "/";
                    }}
                >
                    <img
                        src={"/assets/images/teedex-logo.png"}
                        alt="Varient logo"
                        className="sidebar-logo-main"
                    />
                    <img
                        src={"/assets/images/teedex-logo-hover.png"}
                        alt="Varient logo"
                        className="sidebar-logo-hover"
                    />
                </Link>
                <Sidebar store={store} />
                <div className="left-main-menu designSidebar">
                    <DesignSidebar />
                </div>
            </SidePanelWrap>
            <WorkspaceWrap
                className="polotno-workspace"
                style={{
                    maxHeight: "100vh",
                    overflow: "hidden",
                }}
            >
                <div className="artboard--main__header--center">
                    <div
                        className="artboard--main__tabs"
                        style={{
                            opacity: 0,
                            visibility: "hidden",
                            height: "2.4vw",
                        }}
                    >
                        {/* <button
                className="artboard--main__tabs--nav__item active"
                // onClick={navigateHomePage}
              >
                Design
              </button>
              <button
                className="artboard--main__tabs--nav__item"
                onClick={handleVariationClick}
              >
                Variation
              </button>
              <button
                className="artboard--main__tabs--nav__item"
                onClick={handleExportClick}
              >
                Export
              </button> */}
                    </div>
                </div>
                <div className="artboard--main__header--right variation-button">
                    <a onClick={goToExportHandler}>
                        <img
                            src={"/assets/images/save_and_exit.svg"}
                            alt="Variation Icon"
                        />
                        Save and go to export
                    </a>
                </div>
                <Toolbar
                    store={store}
                    components={{
                        TextFontFamily: customFontFamily,
                        TextAiWrite,
                        ImageSetBackgroundButton,
                        ImageStretch,
                        TextTransform: None,
                        TextUpperCase: TextUpperCaseButton,
                        Position: SizeControls,
                        FigureFitToPage,
                        // TextOverflowToggle: () => (
                        //     <TextOverflowToggle
                        //         isTextOverFlowOn={isTextOverFlowOn}
                        //         setIsTextOverFlowOn={setIsTextOverFlowOn}
                        //         store={store}
                        //     />
                        // )
                        // TextInfo,
                        TextAutoFitToggle

                    }}
                />
                {isPageReady && (
                    <Workspace
                        renderOnlyActivePage
                        store={store}
                        components={{
                            PageControls: ({
                                store,
                                page,
                                xPadding,
                                yPadding,
                            }) => {
                                /*  const hasManyPages = store.pages.length > 1;
                                 const index = store.pages.indexOf(page); */
                                return (
                                    <div className="artboard-page-controls">
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: yPadding - 20 + "px",
                                                left: xPadding + "px",
                                            }}
                                            className="artboard-page"
                                        >
                                            <EditableText
                                                disabled
                                                className="artboard-page-name"
                                                value={
                                                    page.id
                                                        ?.split("_")
                                                        .join(" ")
                                                        ?.toUpperCase() ||
                                                    "Untitled page"
                                                }
                                                onChange={(val) => {
                                                    page.set({
                                                        custom: {
                                                            ...page.custom,
                                                            name: val,
                                                        },
                                                    });
                                                }}
                                            />
                                            <EditableText
                                                className="artboard-page-size"
                                                disabled
                                                value={page.custom[sizeFormat]}
                                                onChange={(val) => {
                                                    page.set({
                                                        custom: {
                                                            ...page.custom,
                                                            name: val,
                                                        },
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: yPadding - 30 + "px",
                                                right: xPadding + "px",
                                            }}
                                            className="artboard-sizes"
                                        >
                                            <select
                                                value={sizeFormat}
                                                onChange={sizeChangeHandler}
                                            >
                                                <option value={"pixels"}>
                                                    Pixels
                                                </option>
                                                <option value={"inch"}>
                                                    Inch
                                                </option>
                                            </select>
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: yPadding - 40 + "px",
                                                right: xPadding + "px",
                                            }}
                                        ></div>
                                    </div>
                                );
                            },
                            TextAiWrite,
                            Tooltip: showTooltip ? Tooltip : null,
                        }}
                        style={{
                            overflow: "hidden",
                        }}
                    />
                )}
                <div className="zoombar">
                    <img
                        src={"/assets/images/zoom_in-icn.svg"}
                        alt="Refresh Icon"
                    />
                    Zoom
                    <CustomeZoombar store={store} />
                </div>
                {/* <ZoomButtons store={store} /> */}

                <TimeLineControllers
                    source="edit"
                    handleUnlockClick={handleUnlockClick}
                />
            </WorkspaceWrap>
        </PolotnoContainer>
    );
}
